import type { Ref } from 'react';
import { EastOutlined } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { IdentityAvatarGroup, designTokens } from '../../../design-system';
import type { StaffingWorker } from '../../staffing/public';

/** Native drag 이미지에 전달할 실제 이동 대상을 한 장으로 요약합니다. */
export function OrganizationStudioDragPreview({ workers, previewRef }: {
  workers: readonly StaffingWorker[];
  previewRef: Ref<HTMLDivElement>;
}) {
  const names = workers.slice(0, 2).map(worker => worker.name).join(', ');
  const summary = workers.length > 2 ? `${names} 외 ${workers.length - 2}명` : names;
  return <Box aria-hidden="true" sx={{ position: 'fixed', top: 0, left: 0, transform: 'translate(-100%, -100%)', pointerEvents: 'none' }}>
    <Stack ref={previewRef} data-testid="studio-worker-drag-preview" direction="row" spacing={1.5}
      sx={{ alignItems: 'center', width: 'max-content', maxWidth: designTokens.layout.detailPanelCompactWidth,
        px: 1.5, py: 1, border: `1px solid ${designTokens.color.brandBorder}`, borderRadius: designTokens.radius.navigation,
        bgcolor: designTokens.color.canvas, color: designTokens.color.primaryText, boxShadow: designTokens.shadow.menu }}>
      <IdentityAvatarGroup items={workers.map(worker => ({ id: worker.id, name: worker.name, src: worker.profilePhotoUrl }))} max={3} size={32} />
      <Stack sx={{ minWidth: 0 }}>
        <Typography variant="subtitle2" sx={{ color: designTokens.color.actionDark }}>{workers.length}명 이동</Typography>
        <Typography variant="caption" color="text.secondary" noWrap>{summary}</Typography>
      </Stack>
      <EastOutlined sx={{ fontSize: designTokens.button.sizes.small.iconSize, color: designTokens.color.actionDark, flexShrink: 0 }} />
    </Stack>
  </Box>;
}
